import React, { useState, useEffect, useCallback } from 'react'
import { BrowserRouter, Route, Link } from "react-router-dom"
import { useMount, useUnmount } from 'react-use'
import { useSelector, useDispatch } from 'react-redux'
import * as apis from '@/apis'
import { Spin, Icon, ConfigProvider } from 'antd'
import GobalSearchDialog from './dialog'
import { sagaModal } from 'redux-saga-modal'
import { Modal } from 'antd'
import * as actions from '@/models/globalSearch/actions'
import styles from './globalSearch.module.scss'

const globalSearchDialog = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={false}
    destroyOnClose
    bodyStyle={{
      backgroundColor: 'transparent',
      padding: 0
    }}
    closable={false}
    footer={null}
    width={1100}
    centered
    visible={isOpen}
    onCancel={hide}>
    <GobalSearchDialog {...ownProps} close={hide} />
  </Modal>
)

const GlobalSearchSagaModal = sagaModal({
  name: 'GLOBAL_SEARCH',
})(globalSearchDialog)

export default function globalSearchKeyProvider() {
  // if (process.env.APP_MODE === 'tenant') {
  //   return null
  // }

  const dispatch = useDispatch()
  const keyHandler = useCallback(event => {
    if (event.composed && event.metaKey && event.keyCode === 70) {
      event.preventDefault()
      dispatch(actions.toggleDialog())
    }
  }, [])
  useEffect(() => {
    window.document.addEventListener('keydown', keyHandler)
    return () => {
      window.document.removeEventListener('keydown', keyHandler)
    }
  }, [])

  return (
    <GlobalSearchSagaModal />
  )
}
